import { createFileRoute } from '@tanstack/react-router';
import { AuthActionPage } from '../components/Auth/AuthActionPage';

export const Route = createFileRoute('/auth/action')({
  component: AuthActionPage,
});
